// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg[data-v-35e21a03]{transform:rotate(180deg);width:39px;height:37px;cursor:pointer;transition:.25s}svg path[data-v-35e21a03]:first-of-type{transition:.25s;fill:#b5b5b5}svg path[data-v-35e21a03]:first-of-type:hover{fill:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
